// extracted by mini-css-extract-plugin
module.exports = {"label":"FilePicker_label__y2mMg","input":"FilePicker_input__1XlxM"};